import { Navigate } from 'react-router-dom';
import { DASHBOARD_HOME_PATH, WELCOME_PATH } from '@/utils/dashboard';

/**
 * O `/bem-vindo` não é tela: o dashboard troca a URL para ele com `pushState` enquanto o modal de
 * boas-vindas está aberto, para o GTM ter uma página de pós-cadastro (CKTPL-205). Quem carrega a
 * página nessa URL (F5, aba restaurada, `lazyWithReload` no deploy, Avançar do navegador) volta
 * para a home, que decide a tela e passa pelo AuthGuard. O modal não reabre: o
 * `welcome_modal_view` já disparou ao abrir, e disparar de novo contaria duas vezes no funil.
 */
export const welcomeRoute = {
  path: WELCOME_PATH.replace(/^\//, ''),
  element: <Navigate to={DASHBOARD_HOME_PATH} replace />,
};
